import { FormNames, IFormDefinition } from '../../models/form/IFormDefinition'
import { AppLinks } from '../../environment/app-links'
import { addressInfoFields, addressInfoFieldValidations } from './AddressInfoFields'

export const adressInfoForm: IFormDefinition = {
   name: FormNames.AddressInfoForm, 
   fields: addressInfoFields,
   urlPath: AppLinks.addressInfoForm,
   nextFormUrlPath: AppLinks.incomeInfoForm,
   canStepBackInForm: false,
   formValidationFunctions: addressInfoFieldValidations,
}